import { render, staticRenderFns } from "./sourceFlow.vue?vue&type=template&id=5800392f&scoped=true&"
import script from "./sourceFlow.vue?vue&type=script&lang=js&"
export * from "./sourceFlow.vue?vue&type=script&lang=js&"
import style0 from "./sourceFlow.vue?vue&type=style&index=0&id=5800392f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5800392f",
  null
  
)

export default component.exports